<form [formGroup]="form" class="row gy-4 px-3 text-color">

    <!-- Title -->
    <div class="col-md-6">
        <label class="form-label fs-18 fg-400">{{ 'TEST_DETAIL.TITLE_F' | translate }}</label>
        <input formControlName="title" type="text" class="form-control bg-input p-3"
            placeholder="{{ 'TEST_DETAIL.TITLE_PLACEHOLDER' | translate }}" />
        <small *ngIf="form.get('title')?.touched && form.get('title')?.hasError('required')" class="text-danger">
            {{ 'VALIDATION.REQUIRED' | translate }}
        </small>
    </div>

    <div class="col-md-6">
        <label class="form-label fs-18 fg-400">{{ 'TEST_DETAIL.TIME_F' | translate }}</label>
        <input type="number" class="form-control bg-input p-3" formControlName="timeLimitMinutes" placeholder="60">
        <small *ngIf="form.get('timeLimitMinutes')?.touched && form.get('timeLimitMinutes')?.hasError('required')"
            class="text-danger">
            {{ 'VALIDATION.REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('timeLimitMinutes')?.touched && form.get('timeLimitMinutes')?.hasError('min')"
            class="text-danger">
            {{ 'VALIDATION.MIN_VALUE' | translate: { min: 5 } }}
        </small>
    </div>

    <!-- Description as textarea -->
    <div class="col-md-12">
        <label class="form-label fs-18 fg-400">{{ 'TEST_DETAIL.DESC_F' | translate }}</label>
        <textarea rows="4" formControlName="description" class="form-control bg-input p-3"
            placeholder="{{ 'TEST_DETAIL.DESC_PLACEHOLDER' | translate }}"></textarea>
    </div>

    <!-- Barème : la note finale est ramenée sur ce total. -->
    <div class="col-md-6">
        <label class="form-label fs-18 fg-400">{{ 'TEST_DETAIL.SCALE_F' | translate }}</label>
        <input formControlName="gradingScale" type="number" min="1" class="form-control bg-input p-3" />
        <small class="form-text">{{ 'TEST_DETAIL.SCALE_HINT' | translate }}</small>
        <small *ngIf="form.get('gradingScale')?.touched && form.get('gradingScale')?.hasError('required')"
            class="text-danger d-block">
            {{ 'VALIDATION.REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('gradingScale')?.touched && form.get('gradingScale')?.hasError('min')"
            class="text-danger d-block">
            {{ 'VALIDATION.MIN_VALUE' | translate:{ min: 1 } }}
        </small>
    </div>

    <!-- Score and Attempts -->
    <div class="col-md-6">
        <!-- Saisie sur le barème (10 sur 20), pas en pourcentage : c'est
             l'unité du professeur. L'équivalent réellement envoyé est rappelé
             dessous, pour que le seuil ne soit jamais implicite. -->
        <label class="form-label fs-18 fg-400">
            {{ 'TEST_DETAIL.PASS_F' | translate }}
            <span class="fg-400 opacity-75">/ {{ form.get('gradingScale')?.value || 20 }}</span>
        </label>
        <input formControlName="passingOnScale" type="number" min="0"
               [max]="form.get('gradingScale')?.value || 20"
               class="form-control bg-input p-3" />
        <small class="fg-400 opacity-75">
            {{ 'TEST_DETAIL.PASS_HINT' | translate:{ percent: passingPercentage } }}
        </small>
        <small *ngIf="form.get('passingOnScale')?.touched && form.get('passingOnScale')?.hasError('required')"
            class="text-danger d-block">
            {{ 'VALIDATION.REQUIRED' | translate }}
        </small>
    </div>

    <div class="col-md-6">
        <label class="form-label fs-18 fg-400">{{ 'TEST_DETAIL.ATTEMPT_F' | translate }}</label>
        <input formControlName="maxAttempts" type="number" min="1" class="form-control bg-input p-3" />
        <small *ngIf="form.get('maxAttempts')?.touched && form.get('maxAttempts')?.hasError('required')"
            class="text-danger">
            {{ 'VALIDATION.REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('maxAttempts')?.touched && form.get('maxAttempts')?.hasError('min')" class="text-danger">
            {{ 'VALIDATION.MIN_VALUE' | translate:{ min: 1 } }}
        </small>
    </div>

    <!-- Options du test. Le brouillage des questions et des réponses n'y
         figure plus : c'est une règle de passation depuis SKILL2ERA-117, tirée
         par séance et appliquée à toutes les épreuves. -->
    <div class="col-12">
        <div class="row g-3">
            <div class="col-md-6 col-lg-3">
                <app-switch-button [label]="'TEST_DETAIL.DISPR_F'" [checked]="form.get('showResultsImmediately')?.value"
                    (toggled)="form.get('showResultsImmediately')?.setValue($event)">
                </app-switch-button>
            </div>
            <div class="col-md-6 col-lg-3" *ngIf="!hideReviewOption">
            <app-switch-button
                [label]="'TEST_DETAIL.REVIEW_F'"
                [checked]="form.get('allowReview')?.value"
                (toggled)="form.get('allowReview')?.setValue($event)">
            </app-switch-button>
            </div>
        </div>
    </div>
</form>